const renderProductsFilterCounter = () => {
  const subCounters = document.querySelectorAll('facet-filters-form .facets__selected');
  const totalCounters = document.querySelectorAll('facet-filters-form .facets__heading-counter');
  const checkboxLists = document.querySelectorAll('.facets-wrap ul.list-unstyled');
  const mobileFacetRemoveBtn = document.querySelector('.mobile-facet-remove');

  let count = [...subCounters].reduce((sum, current) => sum + parseInt(current.innerText.replace(/[^\d]/g, '')), 0);

  const totalCount = count > 0 ? `(${count})` : '';

  totalCounters.forEach((counter) => (counter.innerText = totalCount));

  if (mobileFacetRemoveBtn) count > 0 ? mobileFacetRemoveBtn.classList.remove('hidden') : mobileFacetRemoveBtn.classList.add('hidden');

  checkboxLists.forEach((list) => {
    const fullList = list.querySelectorAll('.facets__item');
    const hiddenItems = list.querySelectorAll('.facets__item.hidden');

    if (fullList.length === hiddenItems.length) {
      list.parentElement.parentElement.parentElement.classList.add('hidden');
    } else {
      list.parentElement.parentElement.parentElement.classList.remove('hidden');
    }
  });
};

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .then(() => {
        endlessScroll = new Ajaxinate();
        switchCollectionsPageFilterTabs();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    endlessScroll = new Ajaxinate();
    switchCollectionsPageFilterTabs();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    renderProductsFilterCounter();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

renderProductsFilterCounter();

// Filters Tabs
function switchCollectionsPageFilterTabs() {
  const tabsNav = document.querySelector('.collections__page-nav');
  const tabsButtons = tabsNav.querySelectorAll('.button');
  const productsContainer = document.querySelector('#ProductGridContainer .collection');

  const switchTab = (element, data) => {
    const allTabs = document.querySelectorAll('[data-tab-type]');

    allTabs.forEach((tab) => tab.hasAttribute(`data-${data}`) ? tab.classList.remove('hidden') : tab.classList.add('hidden') );
    tabsButtons.forEach((btn) => btn.classList.remove('active'));
    element.classList.add('active');

    data == 'subscribe-products'
      ? productsContainer.classList.add('subscribe-products')
      : productsContainer.classList.remove('subscribe-products')
  };

  let el, dataType;

  if (tabsNav) {
    if (localStorage.getItem('collectionsTab')) {
      dataType = localStorage.getItem('collectionsTab');
      el = [...tabsButtons].filter((tab) => tab.getAttribute('data-btn-type') == dataType)[0];
    } else {
      el = tabsNav.querySelector('.button');
      dataType = el.getAttribute('data-btn-type');
      localStorage.setItem('collectionsTab', dataType);
    }

    switchTab(el, dataType);

    tabsNav.addEventListener('click', (e) => {
      const el = e.target;

      if (el.classList.contains('button')) {
        const dataType = el.getAttribute('data-btn-type');

        switchTab(el, dataType);

        localStorage.setItem('collectionsTab', dataType);
      }
    });
  }
};

// Mobile filters navigation
function switchMobileFilterNavigation(action) {
  if (action == 'open') {
    document.querySelector('aside.mobile-position').classList.add('active');
  } else if (action == 'close') {
    document.querySelector('aside.mobile-position').classList.remove('active');
  } else {
    return;
  }
}

function rebuildRechargeSubscription() {
  if (!window.ReCharge.products) window.ReCharge.products = [];
  const elements = document.querySelectorAll('[data-action="recharge_subscription"]');

  elements?.forEach((element) => {
    if (!element.dataset.initialized) {
      let variant_to_duplicate = element.dataset.productVariantToDuplicate.replace(/'/g, '"');
      let variant_to_price = element.dataset.productVariantToPrice.replace(/'/g, '"');
      let duplicate_to_price = element.dataset.productDuplicateToPrice.replace(/'/g, '"');

      const product = {
        id: parseInt(element.dataset.productId),
        subscription_only: element.dataset.productSubscriptionOnly === 'true' ? true : false,
        discount_percentage: parseInt(element.dataset.productDiscountPercentage),
        variant_to_duplicate: JSON.parse(variant_to_duplicate.replace(', ', '')),
        variant_to_price: JSON.parse(variant_to_price.replace(', ', '')),
        duplicate_to_price: JSON.parse(duplicate_to_price.replace(', ', '')),
        price_selector: element.dataset.productPriceSelector,
      };

      if (!window.ReCharge) {
        window.ReCharge = new rcWidget(options);
      }
      ReCharge.addProduct(product);
      ReCharge.run();
      element.dataset.initialized = true;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const collectionElement = document.querySelector('#ProductGridContainer');
  const mutationConfig = {
    attributes: true,
    childList: true,
    subtree: true,
  };

  const bindCollectionEvents = () => {
    yotpo.initWidgets();
    rebuildRechargeSubscription();
  };

  const observer = new MutationObserver(bindCollectionEvents);

  observer.observe(collectionElement, mutationConfig);
});

// Init functions
switchCollectionsPageFilterTabs();
